export default "__VITE_ASSET__56e684f5__"